import React from "react";
import GriffInput from "../commons/GriffInput.jsx";
import SidebarFrame from "./SidebarFrame";
import CheckboxInput from "oc-ui/react/CheckboxInput";
import Select from "../commons/Select.jsx";
import SchrankInput from "../commons/SchrankInput.jsx";

export default class NeuerSchrankSettings extends SidebarFrame {
    constructor(props) {
        super(props);

        let modelsForDirection = this.props.schrank.possibleNeighborCombinations[this.props.direction];
        const rotationPossibleWithOneModel = modelsForDirection.some((model) => model.rotation === true);

        this.state = {
            defaultModelleList: _.values(APP.metadata.Modelle),
            modelleList: _.values(APP.metadata.Modelle),
            filterForRotation: false,
            newSchrankInEcke: false,
            selected: modelsForDirection.length > 0 ? modelsForDirection[0] : null,
            modelsForDirection: modelsForDirection,
            rotationPossibleWithOneModel: rotationPossibleWithOneModel,
        };
    }

    renderTitle() {
        return I18N("neuerSchrank");
    }

    renderBody() {
        const modelsForDirection = this.state.filterForRotation
            ? this.state.modelsForDirection.filter((model) => model.rotation === true)
            : this.state.modelsForDirection;
        modelsForDirection.forEach(model => {
            model.image = SETTINGS.wkfgContentBaseUrl + "Konfiguration/" + model.addable + "/screenshot_0_closed.jpg";
        });

        const images = modelsForDirection.map(model => model.image);

        if (this.state.modelsForDirection.length > 0 && this.state.selected) {
            return (
                <div className="appear">
                    <h3>{I18N("settingsForNewSchrank")}</h3>
                    <hr></hr>
                    {(this.props.direction === "left" || this.props.direction === "right") && this.state.rotationPossibleWithOneModel && (
                        <div>
                            <CheckboxInput
                                id={"inspiration"}
                                label={I18N("RotateNewSchrank")}
                                value={this.state.filterForRotation}
                                onChange={() => this.rotationCheckbox()}
                            />
                            <hr></hr>
                        </div>
                    )}

                    {this.state.filterForRotation && (
                        <div>
                            <CheckboxInput
                                id={"newSchrankInEcke"}
                                label={I18N("Neuer Schrank in der Ecke?")}
                                value={this.state.newSchrankInEcke}
                                onChange={() => this.setState({ newSchrankInEcke: !this.state.newSchrankInEcke })}
                            />
                            <hr></hr>
                        </div>
                    )}

                    {/* <Select
                        label={I18N("Welche Form soll der neue Schrank haben?")}
                        value={this.state.selected}
                        options={modelsForDirection}
                        getLabel={(x) => x.addable}
                        isSameValue={(a, b) => a.addable === b.addable}
                        onChange={(modell) => this.setState({ selected: modell })}
                    /> */}

                    <SchrankInput
                        value={this.state.selected} 
                        values={modelsForDirection}
                        getLabel={(model) => _.find(APP.metadata.Inspirationen, (inspiration) => inspiration.Code === model.addable).Label}
                        onChange={(model) => this.setState({ selected: model })}
                    ></SchrankInput>

                    <hr></hr>
                    <button className="button primary big-button" onClick={() => this.addSchrank()}>
                        {I18N("Hinzufuegen")}
                    </button>
                </div>
            );
        } else {
            return (
                <div className="appear">
                    <h3>{I18N("Kein neuer Schrank zulässig.")}</h3>
                </div>
            );
        }
    }

    rotationCheckbox() {
        const modelsForDirection = this.state.modelsForDirection.filter((model) => model.rotation === !this.state.filterForRotation);
        this.setState({
            filterForRotation: !this.state.filterForRotation,
            selected:
                (this.state.selected && this.state.selected.rotation !== !this.state.filterForRotation) ? modelsForDirection[0] : this.state.selected,
        });
    }

    async addSchrank() {
        APP.arrangement.addSchrank({
            schrank: this.props.schrank,
            selected: this.state.selected,
            direction: this.props.direction,
            offset: this.state.selected.abstand,
            rotation: this.state.filterForRotation,
            newSchrankInEcke: this.state.newSchrankInEcke
        });
        APP.uiHandler.ui.showSidebar(this.props.sidebarBefore);
    }
}
